import React, { ReactNode } from 'react';
import Stack from '../Stack/Stack';
import Text from '../Text/Text';

type Props = {
  /** The title slot */
  title: ReactNode;

  /** The value slot */
  value?: ReactNode;

  /** Hide the value from hotjar */
  suppressValue?: boolean;
};

const TableRow = ({ title, value, suppressValue }: Props) => {
  return (
    <Stack
      row
      justifyContent="space-between"
      space={2}
      py={2}
      borderBottom="solid 1px"
      borderColor="gray-200"
      sx={{
        ':last-child': { borderWidth: 0, pb: 1 },
      }}
    >
      {typeof title === 'string' ? <Text muted>{title}</Text> : title}
      {typeof value === 'string' ? (
        <Text {...(suppressValue ? { 'data-hj-suppress': true } : {})}>
          {value}
        </Text>
      ) : (
        value
      )}
    </Stack>
  );
};

TableRow.displayName = 'TableRow';
export default TableRow;
